import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "no-gutters text-center pb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  property: "itemListElement",
  typeof: "ListItem"
}, [
  /*#__PURE__*/_createElementVNode("a", {
    property: "item",
    typeof: "WebPage",
    title: "Go to EveryLink.",
    href: "/",
    class: "home"
  }, [
    /*#__PURE__*/_createElementVNode("span", { property: "name" }, "EveryLink")
  ]),
  /*#__PURE__*/_createElementVNode("meta", {
    property: "position",
    content: "1"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  property: "itemListElement",
  typeof: "ListItem"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, " > "),
  /*#__PURE__*/_createElementVNode("a", {
    property: "item",
    typeof: "WebPage",
    title: "Go to EveryLink.",
    href: "/people",
    class: "home"
  }, [
    /*#__PURE__*/_createElementVNode("span", { property: "name" }, "People")
  ]),
  /*#__PURE__*/_createElementVNode("meta", {
    property: "position",
    content: "1"
  })
], -1)
const _hoisted_4 = {
  property: "itemListElement",
  typeof: "ListItem"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "d" }, " > ", -1)
const _hoisted_6 = {
  key: 1,
  property: "name"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("meta", {
  property: "position",
  content: "3"
}, null, -1)
const _hoisted_8 = { class: "link-content mb-5" }
const _hoisted_9 = {
  key: 0,
  class: "row"
}
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "mb-5 d-flex align-items-center justify-content-between" }
const _hoisted_12 = { class: "mb-0" }
const _hoisted_13 = { class: "d-flex align-items-center gap-3" }
const _hoisted_14 = {
  key: 0,
  class: "col-12"
}
const _hoisted_15 = { class: "col-12 col-lg" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "col-12 col-lg" }
const _hoisted_19 = { class: "text-left" }
const _hoisted_20 = ["href"]
const _hoisted_21 = {
  key: 1,
  class: "row"
}
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = { class: "mb-5 d-flex align-items-center justify-content-between" }
const _hoisted_24 = { class: "mb-0" }
const _hoisted_25 = {
  key: 3,
  class: "d-flex align-items-center gap-3"
}
const _hoisted_26 = { class: "col-12 col-lg" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "col-12 col-lg" }
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = { class: "comments-area" }
const _hoisted_31 = {
  key: 0,
  class: "comments-title"
}
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 2,
  class: "comment-list"
}
const _hoisted_34 = {
  key: 3,
  class: "comment-list"
}
const _hoisted_35 = { class: "custom-comment" }
const _hoisted_36 = { class: "author" }
const _hoisted_37 = { class: "mb-0" }
const _hoisted_38 = { class: "comment-content py-2 ps-5" }
const _hoisted_39 = { class: "reply-and-time" }
const _hoisted_40 = { class: "time" }
const _hoisted_41 = { class: "comment-respond" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h3", {
  id: "reply-title",
  class: "comment-reply-title"
}, "Leave a Reply", -1)
const _hoisted_43 = { class: "logged-in-as" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("a", { href: "/profile-edit" }, "Edit your profile", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "required-field-message" }, [
  /*#__PURE__*/_createTextVNode("Required fields are marked "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_46 = { class: "comment-form-comment" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { for: "comment" }, [
  /*#__PURE__*/_createTextVNode("Comment"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-lg btn-primary",
  type: "submit"
}, "Post Comment", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeletor = _resolveComponent("Skeletor")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, [
        _hoisted_5,
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_Skeletor, {
              key: 0,
              class: "d-inline-block",
              width: "140",
              height: "15"
            }))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, "Post > " + _toDisplayString(_ctx.getAuthorFullName), 1)),
        _hoisted_7
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.post?.metaInput)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_router_link, {
                  to: `/person/?id=${_ctx.post?.author.wpId}`,
                  class: "d-flex align-items-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "avatar avatar--mini flex-shrink-0 me-1",
                      style: _normalizeStyle({ backgroundImage: `url(${_ctx.post?.author.avatar})` })
                    }, null, 4),
                    _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.getAuthorFullName), 1)
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.getFormatDatePost), 1),
                  (_ctx.currentUser.wpId === _ctx.post?.author.wpId)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deletePost && _ctx.deletePost(...args))),
                        class: "btn btn-sm btn-danger"
                      }, "Delete Post"))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (_ctx.post?.authorContent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.post?.authorContent), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              (_ctx.post?.metaInput?.sourceUrl && _ctx.getYouTubeId)
                ? (_openBlock(), _createElementBlock("iframe", {
                    key: 0,
                    width: "560",
                    height: "315",
                    src: `https://www.youtube.com/embed/${_ctx.getYouTubeId}`,
                    frameborder: "0",
                    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                    allowfullscreen: ""
                  }, null, 8, _hoisted_16))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.post.metaInput.image,
                    alt: "",
                    class: "d-block w-100 mb-4"
                  }, null, 8, _hoisted_17))
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.post?.title), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.post?.description), 1),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("a", {
                  href: _ctx.post?.metaInput.sourceUrl,
                  class: "btn btn-lg btn-primary",
                  target: "_blank"
                }, " Open link ", 8, _hoisted_20)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createBlock(_component_Skeletor, {
                      key: 0,
                      class: "d-inline-block",
                      width: "140",
                      height: "15"
                    }))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: `/person/?id=${_ctx.post?.author.wpId}`,
                      class: "d-flex align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "avatar avatar--mini flex-shrink-0 me-1",
                          style: _normalizeStyle({ backgroundImage: `url(${_ctx.post?.author.avatar})` })
                        }, null, 4),
                        _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.getAuthorFullName), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])),
                (_ctx.isLoading)
                  ? (_openBlock(), _createBlock(_component_Skeletor, {
                      key: 2,
                      class: "d-inline-block",
                      width: "140",
                      height: "15"
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.getFormatDatePost), 1),
                      (_ctx.currentUser?.wpId === _ctx.post?.author?.wpId)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deletePost && _ctx.deletePost(...args))),
                            class: "btn btn-sm btn-danger"
                          }, "Delete Post"))
                        : _createCommentVNode("", true)
                    ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              (_ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_Skeletor, {
                    key: 0,
                    class: "d-inline-block",
                    width: "560",
                    height: "315"
                  }))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.post?.image,
                    alt: "",
                    class: "d-block w-100 mb-4"
                  }, null, 8, _hoisted_27))
            ]),
            _createElementVNode("div", _hoisted_28, [
              (_ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_Skeletor, {
                    key: 0,
                    class: "mb-3",
                    width: "360",
                    height: "20"
                  }))
                : _createCommentVNode("", true),
              (_ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_Skeletor, {
                    key: 1,
                    class: "mb-3",
                    width: "160",
                    height: "20"
                  }))
                : _createCommentVNode("", true),
              (_ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_Skeletor, {
                    key: 2,
                    class: "mb-3",
                    width: "60",
                    height: "30",
                    pill: ""
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("p", null, _toDisplayString(_ctx.post?.authorContent), 1)
            ])
          ]))
    ]),
    _createElementVNode("div", _hoisted_30, [
      (_ctx.post?.metaInput)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_31, [
            _createTextVNode(_toDisplayString(_ctx.post?.comments.length) + " comments on “", 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.post?.title), 1),
            _createTextVNode("”")
          ]))
        : (_openBlock(), _createElementBlock("h4", _hoisted_32, _toDisplayString(_ctx.post?.comments.length) + " comments", 1)),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("ol", _hoisted_33, [
            _createVNode(_component_Skeletor, {
              class: "mb-3",
              width: "100%",
              height: "50",
              pill: ""
            }),
            _createVNode(_component_Skeletor, {
              class: "mb-3",
              width: "100%",
              height: "50",
              pill: ""
            }),
            _createVNode(_component_Skeletor, {
              class: "mb-3",
              width: "100%",
              height: "50",
              pill: ""
            })
          ]))
        : (_openBlock(), _createElementBlock("ol", _hoisted_34, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.post?.comments, (comment) => {
              return (_openBlock(), _createElementBlock("div", {
                key: comment?._id,
                class: "custom-comment-holder"
              }, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_router_link, {
                      to: _ctx.currentUser?.wpId === comment.user.wpId ? '/' : `/person/?id=${comment.user.wpId}`,
                      class: "d-flex align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "avatar avatar--mini flex-shrink-0 me-3",
                          style: _normalizeStyle({ backgroundImage: `url(${comment?.user.avatar})` })
                        }, null, 4),
                        _createElementVNode("p", _hoisted_37, _toDisplayString(comment?.user.firstName) + " " + _toDisplayString(comment?.user.lastName), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createElementVNode("div", _hoisted_38, _toDisplayString(comment.text), 1)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.formatCommentDate(comment.created_at)), 1)
                ])
              ]))
            }), 128))
          ])),
      _createElementVNode("div", _hoisted_41, [
        _hoisted_42,
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addComment && _ctx.addComment(...args)), ["prevent"])),
          class: "comment-form"
        }, [
          _createElementVNode("p", _hoisted_43, [
            _createTextVNode("Logged in as " + _toDisplayString(_ctx.currentUser?.email) + " ", 1),
            _hoisted_44,
            _createTextVNode(". "),
            _hoisted_45
          ]),
          _createElementVNode("p", _hoisted_46, [
            _hoisted_47,
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.commentValue) = $event)),
              id: "comment",
              name: "comment",
              cols: "45",
              rows: "8",
              maxlength: "65525",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.commentValue]
            ])
          ]),
          _hoisted_48
        ], 32)
      ])
    ])
  ], 64))
}